import { render } from "./TableCalendarModal.vue?vue&type=template&id=4c5a7bce&ts=true"
import script from "./TableCalendarModal.vue?vue&type=script&lang=ts"
export * from "./TableCalendarModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__